import React from "react";
import { FaChevronDown } from "react-icons/fa";
import { Editor } from "react-draft-wysiwyg";
import { useEditStudy } from "../../../hooks/useEditStudy";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./EditStudy.css";
import "../study.css";

const EditStudy = ({ show, onClose, study }) => {
  const {
    formData,
    editorAbstract,
    editorProtocol,
    setEditorAbstract,
    setEditorProtocol,
    handleChange,
    handleSubmit,
  } = useEditStudy(study, onClose);

  return (
    <div
      className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
      style={{
        visibility: show ? "visible" : "hidden",
        backgroundColor: "white",
        zIndex: 1050,
      }}
      tabIndex="-1"
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="offcanvas-title">Modifier l'étude</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => onClose(false)}
        ></button>
      </div>

      <div className="offcanvas-body d-flex flex-column">
        <form
          onSubmit={handleSubmit}
          className="d-flex flex-column flex-grow-1"
        >
          <div className="flex-grow-1 overflow-auto pe-1">
            {/* --- Nom --- */}
            <div className="mb-3">
              <div className="study-field py-1 px-4 flex-grow-1 w-100">
                <span className="study-field-label">Nom de l'étude</span>
                <input
                  type="text"
                  name="name"
                  className="w-100"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* --- Contact --- */}
            <div className="mb-3">
              <div className="study-field py-1 px-4 w-100">
                <span className="study-field-label">Contact de l'étude</span>
                <input
                  type="email"
                  name="contact"
                  className="w-100 "
                  value={formData.contact}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* --- Résumé --- */}
            <div className="mb-3">
              <a
                className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
                data-bs-toggle="collapse"
                href="#collapseAbstract"
                role="button"
                aria-expanded="true"
                aria-controls="collapseAbstract"
              >
                <span>Résumé de l'étude</span>
                <FaChevronDown />
              </a>
              <div className="collapse show py-2 px-3" id="collapseAbstract">
                <Editor
                  editorState={editorAbstract}
                  onEditorStateChange={setEditorAbstract}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor border p-2 rounded bg-white"
                  toolbar={{
                    options: ["inline", "list", "textAlign", "history"],
                    inline: { options: ["bold", "italic", "underline"] },
                  }}
                />
              </div>
            </div>

            {/* --- Protocole --- */}
            <div className="mb-3">
              <a
                className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
                data-bs-toggle="collapse"
                href="#collapseProtocol"
                role="button"
                aria-expanded="true"
                aria-controls="collapseProtocol"
              >
                <span>Protocole</span>
                <FaChevronDown />
              </a>
              <div className="collapse show py-2 px-3" id="collapseProtocol">
                <Editor
                  editorState={editorProtocol}
                  onEditorStateChange={setEditorProtocol}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor border p-2 rounded bg-white"
                  toolbar={{
                    options: ["inline", "list", "textAlign", "history"],
                    inline: { options: ["bold", "italic", "underline"] },
                  }}
                />
              </div>
            </div>
          </div>

          {/* --- Sticky Save Button --- */}
          <div className="offcanvas-footer mt-auto pt-3 border-top bg-white">
            <button type="submit" className="study-btn w-100">
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStudy;
